module.exports = __webpack_public_path__ + "static/img/RP-U24H5_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RP-U24H5_1.png
// module id = 0uLD
// module chunks = 0